module.exports = __webpack_public_path__ + "static/img/text.cbb4ef6c.png";